import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const Shield = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 24 24">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22C12 22 20 18 20 12V5.00003L12 2.00003L4 5.00003V12C4 18 12 22 12 22Z" fill="#FDFDFD" stroke="#808C92" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    </SvgIcon>
  );
}

export default Shield;



